<template>
  <div class="uk-alert uk-alert-warning dcs-alert">
    <content-section :content-key="errorType" :law="law" :brand="brand"/>
  </div>
</template>

<script>
import ContentSection from "./elements/ContentSection";

export default {
  name: "error-page",
  components: { ContentSection },
  props: {
    errorType: String,
    law: String,
    brand: String
  }
};
</script>

<style scoped></style>
